export default __webpack_public_path__ + "static/media/strawberry-lime-and-vanilla-panna-cotta.ffd4f90b.png";